import React, { FocusEvent } from "react";
import { Row, Col } from "react-bootstrap";
import { ActionHandlerFunction, AdminUserBase } from "@preveil-api";
import { DriveUIActionTypes, getSelectedState, useAppSelector, isSameUser, CheckboxStates } from "src/common";
import { Checkbox, Loading } from "src/components";
import { ListRow } from ".";
import { RootState } from "src/store/configureStore";
import _ from "lodash";

type AllProps = {
	users_list: AdminUserBase[];
	handleAction: ActionHandlerFunction;
	is_loading?: boolean;
};

function ListViewComponent(props: AllProps) {
	const { users_list, handleAction, is_loading } = props;
	const selected = useAppSelector((state: RootState) => state.admin.selected);
	const users_shards_statuses = useAppSelector((state: RootState) => state.admin.users_with_export_shards);
	// Description: Render the rows of Admin Users view
	function RenderList(_list: AdminUserBase[]) {
		return (
			<div className="list-body">
				{_.map(_list, (_user: AdminUserBase, i: number) => {
					const user_id = _user.user_id;
					const is_shards_submitted = users_shards_statuses?.some(user_shards => isSameUser(user_id, user_shards)) ?? false;
					const is_user_selected = selected.some(selected_user_id => isSameUser(selected_user_id, user_id));
					return (
						<ListRow
							key={`item_${i}`}
							is_shards_submitted={is_shards_submitted}
							user={_user}
							handleAction={handleAction}
							selected={is_user_selected}
						/>
					);
				})}
			</div>
		);
	}

	return (
		<div className="admin-list-view compact">
			{!!users_list && users_list.length > 0 && (
				<Row className="header-row">
					<Col md="1">
						<Checkbox
							className="sr-only"
							onChange={(_e: FocusEvent<HTMLInputElement>) => {
								const current_state = getSelectedState(selected, users_list.length);
								handleAction({
									actionType: DriveUIActionTypes.Select,
									params: { selected: current_state === CheckboxStates.empty },
								});
							}}
							value="all"
							label="Select All"
							disabled={users_shards_statuses.length === 0}
							selected={getSelectedState(selected, users_list.length)}
						/>
					</Col>
					<Col md="3" className="col">Name</Col>
					<Col md="5">Email</Col>
					<Col md="3">Department</Col>
				</Row>
			)}
			{is_loading ? (
				<Loading className="in-place" />
			) : (
				RenderList(users_list)
			)}
		</div>
	);
}

export default React.memo(ListViewComponent);
